import { useIsTeamsContrastTheme } from './selectors';

export const useShouldEmulateHighContrastInTeams = () => {
  const isTeamsContrastTheme = useIsTeamsContrastTheme();
  const isWindowsHighContrastActive = window.matchMedia && window.matchMedia('(forced-colors: active)').matches;

  // Only emulate high contrast in-app if Teams contrast theme is selected but system contrast is disabled.
  return isTeamsContrastTheme && !isWindowsHighContrastActive;
};
